import { useAppContext } from "@overrides_venia/peregrine/context/app";
import { env } from "build/env";
import { isTakeawayLinkUnavailable } from "./onlineOrdering";
export default function useTakeawayLinkUnavailable(href) {
  const [{
    stores
  }] = useAppContext();
  const hosts = [env.URL_TAKEAWAY, env.URL_TAKEAWAY_CH, env.URL_MISCUSI].filter(Boolean).map(value => {
    try {
      return new URL(value.includes("://") ? value : "https://".concat(value)).host;
    } catch (error) {
      return "";
    }
  });
  return isTakeawayLinkUnavailable(href, stores, window.location.href, hosts);
}